import React from 'react';

export const getSearchFormId = (trainingPlanIid) => {
  return `search_training_plan_planned_users_${trainingPlanIid}`;
};
